/* Built In Imports */
/* External Imports */
import { Box, Flex } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import SectionTitle from '@components/Headings/SectionTitle';
import SingleLineText from '@components/UI/SingleLineText';
import ProSchedTabCont from '@landing_pages/GoY/ProSchedTabCont';

/* Services */

/**
 * @param section.section
 * @param {object} section
 * @param section.region
 * @param section.lang
 * @returns
 */
const OnlineProgramDetails = ({ section, region, lang }) => {
  return (
    <Box id="programschedule">
      <SectionTitle titleObj={section?.sectionContent[0]} />
      <SingleLineText
        sectionContent={section?.sectionContent[1]}
        lineHeight={'30px'}
        fontStyle="italic"
      />
      <Box
        width={{ lg: '970px', sm: '90%' }}
        m={{ base: "0 auto", md: "30px auto 0" }}
        id="proSched"
      >
        {section.sectionContent?.length > 3 && (
          <Flex>
            <ProSchedTabCont
              {...section.sectionContent[3].data[0]}
              region={region}
            />
          </Flex>
        )}
      </Box>
    </Box>
  );
};

export default OnlineProgramDetails;
